import React, { Children, cloneElement, isValidElement } from 'react';
import { bool, node, shape, string } from 'prop-types';
import clsx from 'clsx';

import defaultClasses from './Tab.module.css';

const Tab = ({
    children,
    classes,
    component: Component,
    error,
    hidden,
    href,
    title,
    ...props
}) => {
    const rootClassName = clsx(
        defaultClasses.root,
        classes.root,
        {
            [defaultClasses.hidden]: hidden
        }
    );

    /**
     * Inject the :hidden prop into each Tab's contents so that they can
     * perform any conditional rendering logic
     */
    const content = Children.map(children, (node, key) => {
        if (!isValidElement(node)) {
            return node;
        }
        return cloneElement(node, {
            ...node.props,
            hidden
        });
    });

    return (
        <div className={rootClassName}>
            <Component className={defaultClasses.container} {...props}>
                {content}
            </Component>
        </div>
    );
};

Tab.defaultProps = {
    classes:   {},
    component: 'article'
};

Tab.propTypes = {
    children: node,
    classes:  shape({
        header: string,
        root:   string
    }),
    component: string,
    hidden:    bool,
    title:     string.isRequired
};

export default Tab;
